import axios from "axios";

import { SERVER_URL } from "constants/serverUrl";
import { getAccessToken } from "utils";

export const listDirectory = (dir, cb) => {
  if (!dir || dir === "null") dir = "";
  axios
    .get(`${SERVER_URL}/medialibrary`, {
      params: { dir },
      headers: { Authorization: getAccessToken() },
    })
    .then((res) => typeof cb === "function" && cb(res.data))
    .catch((err) => typeof cb === "function" && cb(null));
};

export const getFileCredit = (filename, cb) => {
  axios
    .get(`${SERVER_URL}/medialibrary/metadata/${filename}`, {
      headers: { Authorization: getAccessToken() },
    })
    .then((res) => typeof cb === "function" && cb(res.data.credit))
    .catch((err) => typeof cb === "function" && cb(null));
};

export const createDirectory = (dir, name, cb) => {
  let fd = new FormData();
  fd.append("dir", dir ? dir : "");
  fd.append("name", name);
  axios
    .post(`${SERVER_URL}/medialibrary/create-directory`, fd, {
      headers: { Authorization: getAccessToken() },
    })
    .then((res) => typeof cb === "function" && cb(res.data))
    .catch((err) => typeof cb === "function" && cb(null));
};

export const uploadFile = async (file, dir, name) => {
  return new Promise((resolve) => {
    let fd = new FormData();
    fd.append("file", file);
    fd.append("dir", dir ? dir : "");
    fd.append("name", name);
    axios
      .post(`${SERVER_URL}/medialibrary/upload`, fd, {
        headers: { Authorization: getAccessToken() },
      })
      .then((res) => resolve(res.data))
      .catch((err) => resolve(null));
  });
};

export const deleteEntry = async (path) => {
  return new Promise((resolve) => {
    let fd = new FormData();
    fd.append("path", path);
    axios
      .post(`${SERVER_URL}/medialibrary/delete`, fd, {
        headers: { Authorization: getAccessToken() },
      })
      .then((res) => resolve(res.data))
      .catch((err) => resolve(null));
  });
};

export function isInside(x, y, z1, z2, z3, z4) {
  let x1 = Math.min(z1, z3);
  let x2 = Math.max(z1, z3);
  let y1 = Math.min(z2, z4);
  let y2 = Math.max(z2, z4);
  if (x1 <= x && x <= x2 && y1 <= y && y <= y2) {
    return true;
  } else {
    return false;
  }
}
